// extracted by mini-css-extract-plugin
export default {"section":"BlogPosts_section__frGLg","link":"BlogPosts_link__UKg2Z","cards":"BlogPosts_cards__EEtfX","button":"BlogPosts_button__R3cET","all":"BlogPosts_all__3Xet9"};